import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import { FONTS, TYPOGRAPHY } from '@/styles';
import { StyleProp, Text, TextStyle, View, ViewStyle } from 'react-native';

interface Props {
  children?: React.ReactNode;
  containerStyle?: StyleProp<ViewStyle>;
  contentMinHeight?: number | null;
  isEditable?: boolean;
  label: string | React.ReactNode;
  labelStyle?: StyleProp<TextStyle>;
}

export const SalesRepInfoCell: React.FC<Props> = ({
  children,
  containerStyle,
  contentMinHeight,
  label,
  labelStyle,
}) => {
  const [styles] = useStyles();

  const content =
    typeof children === 'number' || typeof children === 'string' ? (
      <SalesRepInfoCellText>{children}</SalesRepInfoCellText>
    ) : (
      children
    );

  return (
    <View style={[styles.base, containerStyle]}>
      <Text
        numberOfLines={1}
        style={[TYPOGRAPHY.smallLabel, FONTS.primary, styles.label, labelStyle]}
      >
        {label}
      </Text>
      {typeof contentMinHeight === 'number' ? (
        <View style={[{ minHeight: contentMinHeight }]}>{content}</View>
      ) : (
        content
      )}
    </View>
  );
};

export const SalesRepInfoCellText: React.FC<{
  children: React.ReactNode;
  style?: StyleProp<TextStyle>;
  testID?: string;
}> = ({ children, style, testID }) => (
  <Text
    numberOfLines={1}
    style={[TYPOGRAPHY.small, FONTS.primarySemiBold, style]}
    testID={testID}
  >
    {children}
  </Text>
);

const useStyles = createStyles((theme) => ({
  base: {
    flex: 1,
    margin: 12,
  },
  label: {
    fontFamily: theme.fonts.primary,
    fontSize: theme.fontSizes.xsmall,
    marginBottom: 2,
    paddingBottom: 4,
  },
}));
